import { Deserializable } from '../deserializable';


export  class LogSearch implements Deserializable
{
  public id: number;
  public staffId: number;
  public keyWord: string;
  public searchForm: string;
  public paramSearch: string;
  public created: Date;

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
